import PersistenceManager from './persistence';
import AnalyticsManager from './analytics';
import BootstrapModal from "../themes/streamlined/Modal";
import React from "react";
import GoogleAnalytics from "../analytics/google";
import {bugsnagClient} from "../themes/streamlined/streamlined";

export default class ItemFunctions {
    /**
     *
     * @param {Event} changeEvent Event triggered by changing the quantity of the total item
     * Responds to direct user input through typing
     */
    static handleItemQuantityChange(changeEvent) {
        let newVal = changeEvent.target.value;
        if(newVal <= 0) newVal = 1;
        this.setState({quantity: newVal});
    }

    /**
     * Increases quantity by 1 to a maximum of 99
     */
    static increaseItemQuantity() {
        const newQuantity = this.state.quantity + 1;
        if(newQuantity < 99) {
            this.setState({quantity: newQuantity});
        }
    }

    /**
     * Decreases quantity by 1 to a minimum of 1
     */
    static decreaseItemQuantity() {
        const newQuantity = this.state.quantity - 1;
        if(newQuantity > 0) {
            this.setState({quantity: newQuantity});
        }
    }

    /**
     *
     * @param {number} itemKey Key of item to select
     */
    static selectMainItem(itemKey) {
        //Selects the main item and persists it to session storage as a courtesy to the user
        const sanitizedKey = parseInt(itemKey);
        let old = this.state;
        old.choices.item = sanitizedKey;
        this.setState({old}, PersistenceManager.setChosenMainItem(sanitizedKey));
    }

    static processSubmitAttempt() {
        let allMods = session.modifiers;
        let choices = this.state.choices;
        let styles = this.state.styles;

        let chosen_mods = [];

        if (typeof choices === 'undefined' || !choices.modifiers || typeof choices.modifiers !== 'object') {
            return ['selection_not_allowed', null, null, null];
        }

        Object.keys(choices.modifiers).map(key => {
            if (choices.modifiers[key].quantity !== 0) {
                chosen_mods.push(key);
            }
        });

        let full_mods_array = [];

        //now use the chosen mods array to create an array with all mod data not just the key
        chosen_mods.map(the_key => {
            allMods.map((mod, i) => {
                if (parseInt(allMods[i].id) === parseInt(the_key)) {
                    full_mods_array.push(allMods[i]);
                }
            })
        });

        //loop over the full mods array to see if the main items level matches the magic -69.69 number
        for (let i = 0; i < full_mods_array.length; i++) {
            let levels = JSON.parse(full_mods_array[i].level_price);
            let level_price = levels[this.state.itemGroup.items[choices.item].level];
            if (level_price === '-69.69') {
                //in pos -69.69 means this is an unavailable selection, tell the user.
                return ['invalid_selection', this.state.itemGroup.items[choices.item], full_mods_array[i],null];
            }
        }

        let required = [];
        let req_count = 0;

        //now we loop over the chosen mods to be certain all required selections are made
        if (styles.length > 0) {
            styles.map(style => {
                if (style.isRadio) {
                    required.push(style);
                    req_count += 1;
                }
            })
        }

        chosen_mods.map(selected_mod => {
            let int_mod = parseInt(selected_mod);
            required.map((req1,i) => {
                req1.modifiers.map(req2 => {
                    if (int_mod === req2 || int_mod === 0) { //todo test this to make sure it does not break things
                        req_count -= 1;
                        delete required[i];
                    }
                })
            })
        });

        //now that we have an array of unfulfilled requirements, loop over it to create a user friendly list.
        let unfulfilled_reqs_friendly_names = [];
        required.map(req => {
            unfulfilled_reqs_friendly_names.push(req.name);
        });

        if (req_count > 0) {
            let reasons = 'Please make the following required selections: ';
            unfulfilled_reqs_friendly_names.map((req,i) => {
                if (unfulfilled_reqs_friendly_names.length > (i + 1)) {
                    reasons += `${req}, `;
                } else {
                    reasons += `${req}.`;
                }
            })
            return ['requirements_unmet',null,null,reasons];
        }


        if(this.state.isValid) {
            //good attempt, show the regular process
            return this.submitCustomization();
        }else {
            return ['selection_not_allowed',null,null,null];
        }
    }

    static selectionNotAllowed() {
        return 'selection_not_allowed';
    }


    static getCartAddErrorMessage(errorResponse) {
        const fallbackMessage = "We couldn’t add this item to your cart. Please try again.";

        if (!errorResponse || typeof errorResponse !== 'object') {
            return fallbackMessage;
        }

        const friendly = errorResponse.friendly && typeof errorResponse.friendly === 'object' ? errorResponse.friendly : {};
        const friendlyDescription = String(friendly.description || errorResponse.description || '').trim();

        if (friendlyDescription) {
            return friendlyDescription;
        }

        const friendlyName = String(friendly.name || errorResponse.name || '').trim();

        if (friendlyName) {
            return friendlyName;
        }

        const message = String(errorResponse.message || '').trim();

        if (message) {
            return message;
        }

        const errorMessage = String(errorResponse.error || '').trim();

        if (errorMessage) {
            return errorMessage;
        }

        const errors = errorResponse.errors;

        if (errors && typeof errors === 'object') {
            for (const key in errors) {
                if (!Object.prototype.hasOwnProperty.call(errors, key)) {
                    continue;
                }

                const firstError = errors[key];

                if (Array.isArray(firstError) && typeof firstError[0] === 'string' && firstError[0].trim().length > 0) {
                    return firstError[0];
                }

                if (typeof firstError === 'string' && firstError.trim().length > 0) {
                    return firstError;
                }
            }
        }

        return fallbackMessage;
    }

    static submitCustomization() {
        if(this.submitCustomizationLock) return undefined; //Simple lock to prevent double clicks
        this.submitCustomizationLock = true;
        let cartCount = window.session.cart_line_count;
        if(cartCount === 0) {
            //prompt for service type
        }
        const choices = this.state.choices;
        choices.category = this.state.categoryName;

        let payload = {
            item: this.state.itemGroup.items[choices.item].id,
            quantity: this.state.quantity,
            modifiers: [],
            addOns: [],
            itemNavigation: this.state.itemNavigationID,
            choices: JSON.stringify(choices),
            comment: this.state.comment,
            category_id: this.state.categoryID
        };

        for (const key in choices.includedModifiers) {
            if (choices.includedModifiers.hasOwnProperty(key)) {
                const incMod = choices.includedModifiers[key];
                // Post every included mod regardless of QTY, as the backend will compare it to what's expected
                    const modObjectRep = {
                        id: parseInt(key),
                        quantity: incMod.quantity,
                        portion: incMod.portion,
                        size: incMod.size
                    };
                    payload.modifiers.push(modObjectRep);
            }
        }

        for (const key in choices.modifiers) {
            if (choices.modifiers.hasOwnProperty(key) && key !== '0') {
                const optMod = choices.modifiers[key];
                if(optMod.quantity > 0) {
                    const modObjectRep = {
                        id: parseInt(key),
                        quantity: optMod.quantity,
                        portion: optMod.portion,
                        size: optMod.size
                    };
                    payload.modifiers.push(modObjectRep);
                }
            }
        }
        let allAddons = {};
        this.state.addonGroups.forEach( (val, ind, arr) => {
            let addOns = val.addons;
            addOns.forEach( (addOn, aInd, aArr) => {
                allAddons[addOn.id] = addOn;
            })
        });
        let addonsForAnalytics = [];
        for (const key in choices.addOns) {
            if (choices.addOns.hasOwnProperty(key)) {
                const addon = choices.addOns[key];
                let analyticAddon = {...allAddons[key], ...addon};
                addonsForAnalytics.push(analyticAddon);
                payload.addOns.push({
                    quantity: addon.quantity,
                    id: parseInt(key)
                });
            }
        }
        let analyticsModifiers = payload.modifiers.map( (aModVal, aModInd, aModArr) => {
            return this.state.modifiers[aModVal.id];
        });
        let hasMainItemChoice = this.state.itemGroup.items.length > 1;
        let chosenMainItem = this.state.itemGroup.items[this.state.choices.item].name;
        let variantString = hasMainItemChoice ? chosenMainItem : '';
        analyticsModifiers.forEach( (analyticsMod, analyticsModInd) => {
            if(analyticsModInd === 0 && !hasMainItemChoice) {
                //No – for start if no item choice
                variantString = variantString + analyticsMod.name;
            }else {
                variantString = variantString + ' – ' + analyticsMod.name;
            }
        });
        let analyticsItem = {
            'name': this.state.name,
            'id': this.state.itemNavigationID,
            'price': this.calculateSubtotalWithoutAddons(),
            'variant': variantString, // chosen main item name
            'quantity': this.state.quantity,
            'category': this.state.categoryName
        };
        let url = window.editLineID ? `${window.relativeURI()}/cart/lines/${window.editLineID}/edit/category/${this.state.categoryID}` : `${window.relativeURI()}/cart/add/api`; //TODO
        let headers = new Headers({
            'X-CSRF-TOKEN': window.session.token,
            'credentials': 'same-origin',
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"});
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: headers
        }).then( async (serverResponse) => {
            if(serverResponse.status > 300 && serverResponse.status < 400) document.location.reload() //Follow redirects
            if(serverResponse.status === 200) {
                try {
                    AnalyticsManager.addItemToCart(analyticsItem, addonsForAnalytics);
                    GoogleAnalytics.addToCart(analyticsItem, addonsForAnalytics);
                } catch (error) {
                    // Analytics must never block a successful cart submission.
                    console.warn('[ItemFunctions] Unable to track add-to-cart analytics.', error);
                }
                this.submitCustomizationLock = false;
                this.setState({itemAdded: true});
                return undefined;
            }

            //Check for error code and conditionally display validators
            this.submitCustomizationLock = false;
            let errorResponse = null;

            try {
                errorResponse = await serverResponse.json();
            } catch (_error) {
                errorResponse = null;
            }

            if(serverResponse.status === 422) {
                this.setState({error: errorResponse});
            }else{
                this.setState({hasServerError: true});
            }

            return ['cart_add_failed', null, null, ItemFunctions.getCartAddErrorMessage(errorResponse)];
        }).catch((error) => {
            this.submitCustomizationLock = false;
            this.setState({hasServerError: true});
            bugsnagClient.notify(error);
            return ['cart_add_failed', null, null, ItemFunctions.getCartAddErrorMessage(null)];
        });
    }

    static handleChangeToItemComment(e) {
        if(e.target.value.length <= 255) {
            this.setState({comment: e.target.value});
        }
    }


    static markAsValid() {
        this.setState({isValid: true});
    }

    static markAsInvalid() {
        this.setState({isValid: false});
    }

    static closeServiceTypeSelector(serviceTypeName) {
        //this is so hacky
        let safeSTName = serviceTypeName ? serviceTypeName : window.session.service_type_name;
        this.setState({showServiceTypeSelector: false, serviceTypeName: safeSTName});
    }

    static showServiceTypes() {
        this.setState({showServiceTypeSelector: true});
    }

    static hideServiceTypes() {
        this.setState({showServiceTypeSelector: false});
    }

    static updateServiceType(serviceType, address) {
        this.setState({serviceTypeName: serviceType.name});
    }

    static numberOfSelections() {
        let numSel = 0;
        let allStyleMods = {};
        for (const mod in this.state.modifiers) {
            if (this.state.modifiers.hasOwnProperty(mod) && mod !== '0') {//Make sure to exclude item selection
                this.state.styles.forEach( (val, ind, arr) => {
                    let styleMods = val.modifiers;
                    styleMods.forEach( (sVal, sInd, sArr) => {
                        allStyleMods[sVal] = true;
                    });
                });
                let isStyleMod = allStyleMods[mod];
                if(!isStyleMod) {
                    //Only proceed to count the mod if it isn't a style mod
                    const choice = this.state.choices.modifiers[mod];
                    numSel = numSel + choice.quantity;
                    if(choice.size === 'extra') {
                        numSel = numSel + 1;
                    }
                }
            }
        }
        return numSel;
    }
}
